import { render, staticRenderFns } from "./addempower.vue?vue&type=template&id=1a6c3f68&scoped=true&"
import script from "./addempower.vue?vue&type=script&lang=js&"
export * from "./addempower.vue?vue&type=script&lang=js&"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./addempower.vue?vue&type=style&index=1&id=1a6c3f68&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6c3f68",
  null
  
)

export default component.exports